import React from 'react';

import ReactDOM from 'react-dom';

interface OwnProps {
  target: HTMLElement;
}

type Props = React.PropsWithChildren<Readonly<OwnProps>>;

const MenuPortal: React.FC<Props> = ({ target, children }) => {
  if (!target) return null;

  return ReactDOM.createPortal(children, target);
};

export default React.memo(MenuPortal);
